import gql from "graphql-tag";
import { AdressFragment, OrderInfoFragment } from "./fragments";

export const createJob = gql`
  mutation addJob($input: JobCreationInput!) {
    addJob(input: $input) {
      message
      code
      error
      data {
        job {
          job_orders {
            ...OrderInfo
          }
        }
      }
    }
  }
  ${OrderInfoFragment}
`;

export const UpdateJobPickup = gql`
  mutation updateJobPickup($input: JobPickupUpdateInput!) {
    updateJobPickup(input: $input) {
      message
      code
      error
      data {
        job {
          job_orders {
            ...OrderInfo
          }
        }
      }
    }
  }
  ${OrderInfoFragment}
`;

export const UPDATE_PARCEL = gql`
  mutation updateParcel($input: ParcelUpdateInput!) {
    updateParcel(input: $input) {
      error
      code
      message
      data {
        parcel_UID
        parcel_description
        parcel_size
        parcel_value
        parcel_amount_to_collect
        parcel_client_reference
      }
    }
  }
`;
export const DELETE_PARCEL = gql`
  mutation deleteParcel($parcelID: ID!) {
    deleteParcel(parcelID: $parcelID) {
      error
      code
      message
      data
    }
  }
`;
export const GET_RECEIVER_BY_ID = gql`
  query receiverById($params: OneReceiverFetchParams) {
    results: receiverById(params: $params) {
      data {
        _id
        receiver_lastname
        receiver_firstname
        receiver_email
        receiver_phone_number
        receiver_specification_address
        receiver_entreprise
        receiver_address {
          ...AdressFragment
        }
      }
    }
  }
  ${AdressFragment}
`;
export const UPDATE_ORDER = gql`
  mutation updateOrder($input: OrderUpdateQueryInput!) {
    updateOrder(input: $input) {
      code
      message
      error
      data {
        ...OrderInfo
      }
    }
  }
  ${OrderInfoFragment}
`;

export const deleteOrder = gql`
  mutation deleteOrder($input: DeleteInput!) {
    deleteOrder(input: $input) {
      code
      error
      message
      data
    }
  }
`;
